module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray-7047716a0013d981cf1961664ed7c3fe.png";